/**
 * @desc ShowInfo API 查看详情的模态框
 *  打开 ShowInfo(a,b,c,d);
 *
 *  @param a   [enum]     可选值：'buyer'|'seller'|'dispute'|'deal'|'settle'|'pay'|'remit'|'deposit'|'userDefine'
 *  @param b   [string|number|F.Info.Result]   获取详情的参数
 *  @param c   [object]   可以选传 模态框样式
 *
 *
 *  @augments  param c :属性如下：
 *                      center：   [boolean] 如果true的情况，则没有标题右方方案；
 *                      minKeyLen：[number]  内容区左侧的宽度；
 *                      style:     [object]  整个模态框样式style
 *                      className: [string]  整个模态框样式className
 *
 *  @augments  param a : 枚举类型的值如下：
 *                      'buyer':        买家详情查看            请将  id          传给 param b
 *                      'seller':       卖方详情查看            请将  id          传给 param b
 *                      'dispute':      争议原因|违约原因查看     请将  disputeCode   传给 param b
 *                                                               : 或者将{disputeCode: string|number, type: 'dispute[争议]' | 'break[违约]'} 传给param b
 *                      'deal':         争议|违约处理详情查看     请将  disputeCode   传给 param b
 *                                                               : 或者将{disputeCode: string|number, type: 'dispute[争议]' | 'break[违约]'} 传给param b
 *                      'settle':       结算情况查看            请将  orderId     传给 param b
 *                      'pay':          付款明细查看            请将  orderId     传给 param b
 *                      'remit':        打款明细查看            请将  orderId     传给 param b
 *                      'deposit':      保证金提现已通过查看     请将  id          传给 param b
 *                      'userDefine':   自定义类型 直接展示 param b 的数据
 *                         此时 param  b的格式为{
 *                                        title: string,                          // 标题
 *                                        describle?: string,                     // 标题描述
 *                                        content: [{key: string, value: string}] // key:内容区左侧值，value:内容区右侧值
 *                                        // 为方便用户自定义content内容，content可以是一个function类型，你可以在里面返回一个react dom
 *                                     }
 */

import React from 'react';
import { Provider } from 'react-redux';
import store from '@@/store';
import ReactDOM from 'react-dom';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Icon, Button } from 'antd';
import { Root } from './style';
import { judgeArr, judgeObj } from '@/shared/functions';


const mapStateToProps = (rootState, ownProps) => ({
  _state: rootState.info,
});

class InfoDom extends React.Component {

  hide = () => {
    dispatch.info.RESET_STATE();
  }

  parentHide = (e) => {
    if (e.target === this.outer) {
      this.hide();
    }
  }

  render() {
    const {show, modalData, center, minKeyLen, style, className, showDaYuFooter, showMoney} = this.props._state;
    const {title, describle, content} = modalData;
    const styleLeft = minKeyLen && minKeyLen !== 'none' ? {minWidth: `${minKeyLen}px`} : {};
    return (
      <Root
        className="souche__modal"
        isShow={!!show}
        onClick={this.parentHide}
        ref={(outer) => {
          this.outer = outer;
        }}
      >
        <div className={`modal__body ${className}`} style={style}>
          <header className={`${center ? 'flex__row-center header--center' : 'flex__row-startE'} body__header`}>
            <div>{title}</div>
            {!center &&
            <div className="hearder_desc">{describle}</div>
            }
            <button type="button" className="btn" onClick={this.hide}><Icon type="close" style={{fontSize: 16}}/>
            </button>
          </header>
          <section className="body__content">
            {content && judgeArr(content) && content.map((item, index) => (
              <div key={`content__${index}`} className="content__line flex__row-startS">
                <div style={styleLeft} className="content__key">
                  {`${item.key}`}
                </div>
                <div className="content__value">
                  {typeof item.value === 'function' ? item.value() : item.value}
                </div>
              </div>
            ))}
            {content && typeof content === 'function' && content()}
          </section>
          {
            showDaYuFooter ?
              <footer className="daYuFooter">
                <Button type="primary" className="btm" onClick={this.hide}>Ok</Button>
              </footer>
              : ''
          }

        </div>
      </Root>
    );
  }
}

const InfoDom2 = connect(mapStateToProps, null, null, {forwardRef: true})(InfoDom);

let componentRef = '';
const createInfo = () => {
  const div = document.createElement('div');
  div.className = 'souche--info';
  document.body.appendChild(div);
  const component = (<Provider store={store}>
    {React.createElement(InfoDom2, {
      ref: (ref) => {
        componentRef = ref;
      },
    })}
  </Provider>);
  ReactDOM.render(component, div);
};
const _checkProps = (a, b, c) => {
  if (a === undefined || b === undefined) {
    console.warn('Info模态框的type参数与params参数为必传参数');
    return false;
  }
  let result = {type: a, params: b};
  if (judgeObj(c)) {
    result = Object.assign({}, result, c);
  }
  Object.keys(result).forEach(key => {
    if (result[key] === undefined) {
      delete result[key];
    }
  });
  return result;
}

export default function ShowInfo(a, b, c) {
  const props = _checkProps(a, b, c);
  if (!props) {
    return;
  }
  if (!componentRef) {
    createInfo();
  }
  dispatch.info.show(props);
}
